var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTorii(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "religious-shinto",
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 H20 V20 H0 Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,10c0,5.247-4.253,9.5-9.5,9.5S.5,15.247,.5,10,4.753,.5,10,.5s9.5,4.253,9.5,9.5Z",
    fill: "hsl(352,100%, 50%)",
    stroke: "hsl(20, 20%, 100%)",
    strokeLinejoin: "round",
    strokeMiterlimit: "4px",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6h-8a0.756 0.756 0 0 0-0.8 0.8 0.756 0.756 0 0 0 0.8 0.8H6.4V13.6a0.756 0.756 0 0 0 0.8 0.8 0.756 0.756 0 0 0 0.8-0.8V10.4h4v3.2a0.756 0.756 0 0 0 0.8 0.8 0.756 0.756 0 0 0 0.8-0.8V7.6h0.4a0.756 0.756 0 0 0 0.8-0.8 0.756 0.756 0 0 0-0.8-0.8zM12 8.8H10.4V7.6h1.6zM9.6 8.8H8V7.6h1.6z",
    fill: "hsl(20, 20%, 100%)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorii);
export default __webpack_public_path__ + "static/media/torii.deae4e40dd8650605112b06dca1dbbc5.svg";
export { ForwardRef as ReactComponent };